import { Card, CardHeader, Grid, Typography } from "@mui/material";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  bindReconcilation,
  dateFormat
} from "../../commonFunctions/CommonFunctions";
import httpDashboard from "../../commonFunctions/htttpClientNew";
import WSChart from "../../Components/Chart/WSChart";
import WSGoogleChart from "../../Components/Chart/WSGoogleChart";
import WSDataGridForDashboard, {
  IColumns
} from "../../Components/DataGrid/WSDataGridForDashboard";
import { IRows } from "../../Components/Filter/WSFilterComponent";
import { IViewAllLinkColumns } from "../../Components/ViewAllLinkGrid/ViewAllLinkGrid";
interface IListData {
  billList: Array<any>;
  summaryList: Array<any>;
}
interface IBarReconciliation {
  xAxisData: Array<IXAxis>;
}
interface IXAxis {
  scaleType: "bar" | "point";
  data: Array<any>;
}

export const FinancialDashboard: React.FC<any> = React.memo((props) => {
  const { control, register, handleSubmit, setValue, reset } = useForm();
  const [billList, setBillList] = useState<any>([]);
  const [billListFull, setBillListFull] = useState<any>([]);
  const [summaryList, setSummaryList] = useState<any>([]);
  const [due30daysList, setDue30daysList] = useState<any>([]);
  const [chechkIssuedList, setChechkIssuedList] = useState<any>([]);
  const [totalPayment, setTotalPayment] = useState<any>([]);
  const [barReconciliationXAxis, setReconciliationXAxis] = useState<any>();
  const [barReconciliationYAxis, setReconciliationYAxis] = useState<any>();
  const [pieReconciliationData, setPieReconciliationData] = useState<any[]>([]);
  const today = new Date();
  const formattedDate = today.toISOString().split("T")[0]; // Extracts 'YYYY-MM-DD'
  const source = {
    url: "Bill/search",
    page: 1,
    pageSize: 10,
    filter: [
      {
        field: "DueDate",
        value: formattedDate,
        operator: "gte"
      }
    ],
    sort: []
  };
  useEffect(() => {
    const getBills = async () => {
      try {
        const response: any = await httpDashboard.get("Bill");
        if (response) {
          const today = new Date();
          today.setHours(0, 0, 0, 0); // Set time to midnight

          // Filter invoices where invoiceDate is >= today
          response.map((item: any) => {
            item.name = item?.supplier?.name;
            item.check = item?.chequeIssued ? "Yes" : "No";
          });
          setBillListFull(response);

          const filteredInvoices = response
            .filter((invoice: any) => {
              const dueDate = new Date(invoice.dueDate);
              return dueDate >= today && invoice.chequeIssued === false; // 💥 Only if cheque not issued;
            })
            .sort((a: any, b: any) => {
              const dateA = new Date(a.dueDate).getTime();
              const dateB = new Date(b.dueDate).getTime();
              return dateA - dateB; // Ascending order by dueDate
            });

          setBillList(filteredInvoices);

          const chkNotIssued = response.filter(
            (item: any) => item.chequeIssued === false
          );
          const chkIssued = response.filter(
            (item: any) => item.chequeIssued === true
          );
          if (response) {
            let chkList: Array<[string, number]> = []; // ✅ Header row
            chkList.push(["Cheque Not Issued", chkNotIssued.length || 0]);
            chkList.push(["Cheque Issued", chkIssued.length || 0]); // Ensure numeric value

            setChechkIssuedList(chkList);
          }
        }
      } catch (error) {
        console.error("Error fetching bills:", error);
      }
    };
    const getSummary = async () => {
      try {
        const response: any = await httpDashboard.get("Bill/payments-today");
        if (response) {
          const filtered = response.filter(
            (item: any) => item.checkIssued === true
          );

          const mapped = filtered.map((item: any) => ({
            ...item,
            check: "Yes" // since we already filtered for checkIssued === true
          }));

          setSummaryList(mapped);
        }
      } catch (error) {
        console.error("Error fetching bills:", error);
      }
    };

    const getPaymentSummary = async () => {
      try {
        const response: any = await httpDashboard.get(
          "Bill/total-payments-today"
        );
        if (response) {
          let paymentTotal: Array<any> = [];
          paymentTotal.push(["Total Ammount", 500000]);
          paymentTotal.push(["Disposal Ammount", response?.totalPayments]);
          setTotalPayment(paymentTotal);
        }
      } catch (error) {
        console.error("Error fetching bills:", error);
      }
    };
    const getDueDateSummary30Days = async () => {
      try {
        const body: any = { page: 1, pageSize: 1000000, filter: [], sort: [] };
        const response: any = await httpDashboard.post("Bill/search", body);
        if (response && response.data) {
          const currentDate = new Date();
          currentDate.setHours(0, 0, 0, 0);
          const futureDate = new Date();
          futureDate.setHours(0, 0, 0, 0);
          futureDate.setDate(currentDate.getDate() + 30);
          const filteredData = response.data.filter((item: any) => {
            const dueDate = new Date(item.dueDate);
            return dueDate >= currentDate && dueDate <= futureDate;
          });

          // Group by dueDate and sum amounts
          const groupedData = filteredData.reduce((acc: any, item: any) => {
            const date = item.dueDate.split("T")[0]; // Extract only the date part
            acc[date] = (acc[date] || 0) + item.amount;
            return acc;
          }, {} as Record<string, number>);

          // Convert to array format and sort by date
          const output = Object.entries(groupedData)
            .map(([date, totalAmount]) => ({
              date,
              totalAmount
            }))
            .sort(
              (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
            );

          setDue30daysList(output);
        }
      } catch (error) {
        console.error("Error fetching bills:", error);
      }
    };
    const getLast6DaysDate = () => {
      const fromDate = dayjs().subtract(6, "day");

      const dateArray: string[] = [];

      for (let i = 0; i <= 6; i++) {
        dateArray.push(fromDate.add(i, "day").format("DD-MM-YYYY"));
      }
      return dateArray;
    };
    const getBarReconciliation = async () => {
      try {
        const response: any = await bindReconcilation();

        if (response) {
          const formatDate = (dateString: string) => {
            const date = new Date(dateString);
            return date.toLocaleDateString("en-GB"); // DD-MM-YYYY
          };

          const reconcilation = response
            .filter((item: any) => item.reconciling === false)
            .reduce((acc: any, item: any) => {
              const formattedDate = formatDate(item.dueDate);
              acc[formattedDate] = (acc[formattedDate] || 0) + item.amount;
              return acc;
            }, {});

          // Group data for checkIssued
          const checkIssued = response
            .filter((item: any) => item.chequeIssued === true)
            .reduce((acc: any, item: any) => {
              const formattedDate = formatDate(item.dueDate);
              acc[formattedDate] = (acc[formattedDate] || 0) + item.amount;
              return acc;
            }, {});

          // Get unique dates
          const uniqueDates = Array.from(
            new Set([
              ...Object.keys(reconcilation),
              ...Object.keys(checkIssued)
            ])
          ).sort((a, b) => {
            const [dayA, monthA, yearA] = a.split("/").map(Number);
            const [dayB, monthB, yearB] = b.split("/").map(Number);
            return (
              new Date(yearA, monthA - 1, dayA).getTime() -
              new Date(yearB, monthB - 1, dayB).getTime()
            );
          });

          // Prepare series data
          const reconcilationValues = uniqueDates.map(
            (date) => reconcilation[date] || 0
          );
          const checkIssuedValues = uniqueDates.map(
            (date) => checkIssued[date] || 0
          );
          setReconciliationXAxis({ data: uniqueDates });
          setReconciliationYAxis([
            { data: reconcilationValues, label: "Reconciliation" },
            { data: checkIssuedValues, label: "Check" }
          ]);

          //setBarReconciliation()
        }
      } catch (error) {
        console.error("Error fetching bills:", error);
      }
    };

    const getPieReconciliation = async () => {
      try {
        const response: any = await bindReconcilation();

        if (response) {
          const today = new Date().setHours(0, 0, 0, 0);

          const totalReconciliation = response
            .filter(
              (item: any) =>
                item.reconciling === true &&
                new Date(item.dueDate).getTime() < today
            )
            .reduce((acc: number, item: any) => acc + item.amount, 0);

          const totalPendingIssue = response
            .filter(
              (item: any) =>
                item.chequeIssued === false &&
                new Date(item.dueDate).getTime() < today
            )
            .reduce((acc: number, item: any) => acc + item.amount, 0);

          const totalIssuedNotReconciled = response
            .filter(
              (item: any) =>
                item.chequeIssued === true && item.reconciling === false
            )
            .reduce((acc: number, item: any) => acc + item.amount, 0);

          const pieChartData = [
            // ["Label", "Value"],
            ["Reconciled (Excl. Today)", totalReconciliation],
            ["Pending Cheque Issue", totalPendingIssue],
            ["Issued but Not Reconciled", totalIssuedNotReconciled]
          ];

          console.log("piechartdata", pieChartData);
          setPieReconciliationData(pieChartData);
        }
      } catch (error) {
        console.error("Error fetching reconciliation data:", error);
      }
    };

    getPaymentSummary();
    getBills();
    getSummary();
    getDueDateSummary30Days();
    getBarReconciliation();
    getPieReconciliation();
  }, []);
  const columns: IViewAllLinkColumns[] = [
    {
      fieldName: "name",
      header: "Name"
    },
    {
      fieldName: "invoiceNo",
      header: "Invoice No",
      type: "default"
    },
    {
      fieldName: "invoiceDate",
      header: "Invoice Date",
      type: "date"
    },
    {
      fieldName: "dueDate",
      header: "Due Date",
      type: "date"
    },
    {
      fieldName: "amount",
      header: "Amount",
      type: "default"
    },
    {
      fieldName: "check",
      header: "Check Issued",
      type: "default"
    }
  ];
  const columnsSummary: IColumns[] = [
    {
      fieldName: "supplierName",
      header: "Name"
    },
    {
      fieldName: "invoiceNo",
      header: "Invoice No",
      type: "default"
    },
    {
      fieldName: "paymentDate",
      header: "Payment Date",
      type: "date"
    },
    {
      fieldName: "amount",
      header: "Amount",
      type: "default"
    },
    {
      fieldName: "check",
      header: "IS CHEQUE ISSUED",
      type: "default"
    }
  ];
  // const columnsSummary: IViewAllLinkColumns[] = [
  //     {
  //         fieldName: 'supplierName',
  //         header: 'Name'
  //     },
  //     {
  //         fieldName: 'invoiceNo',
  //         header: 'Invoice No',
  //         type: 'default'
  //     },
  //     {
  //         fieldName: 'paymentDate',
  //         header: 'Payment Date',
  //         type: 'date'
  //     },
  //     {
  //         fieldName: 'amount',
  //         header: 'Amount',
  //         type: 'default'
  //     },

  // ]
  // const columns30days: IViewAllLinkColumns[] = [
  //     {
  //         fieldName: 'date',
  //         header: 'Due Date'
  //     },
  //     {
  //         fieldName: 'totalAmount',
  //         header: 'Total Amount',
  //         type: 'default'
  //     },

  // ]
  const columns30days: IColumns[] = [
    {
      fieldName: "date",
      header: "Due Date"
    },
    {
      fieldName: "totalAmount",
      header: "Total Amount",
      type: "default"
    }
  ];
  const handleFilterchange = (evt: any) => {
    const today = new Date(evt);
    today.setHours(0, 0, 0, 0); // Set time to midnigh
    const filteredInvoices = billListFull.filter((invoice: any) => {
      const dueDate = new Date(invoice.dueDate);
      return dueDate.getTime() === today.getTime();
    });
    setBillList(filteredInvoices);
  };

  const columnsDataBill: IColumns[] = [
    {
      header: "Supplier Name",
      fieldName: "name",
      type: "default"
    },
    {
      header: "Invoice No",
      fieldName: "invoiceNo",
      type: "default"
    },
    {
      header: "Amount",
      fieldName: "amount",
      type: "currency"
    },
    {
      header: "Invoice Date",
      fieldName: "invoiceDate",
      type: "date"
    },
    {
      header: "Due Date",
      fieldName: "dueDate",
      type: "date"
    },

    {
      header: "Category",
      fieldName: "category",
      type: "default"
    },

    {
      header: "Is Cheque Issued",
      fieldName: "chequeIssued",
      type: "booleanToString",
      groupType: "boolean"
    }
  ];
  const transFormData = (data: any) => {
    if (data) {
      data.map((item: any) => {
        item.name = item?.supplier?.name;
        item.check = item?.chequeIssued ? "Yes" : "No";
      });
      return data;
    }
  };
  const filterRows: IRows[] = [
    {
      label: "Name",
      fieldName: "Supplier.Name",
      type: "text",
      operator: "like"
    },
    {
      label: "Due Name",
      fieldName: "DueDate",
      type: "date",
      dateFormat: "YYYY-MM-DD",
      operator: "eq"
    },
    {
      label: "",
      fieldName: "IsHold",
      type: "checkbox",
      options: [{ label: "Is Hold", value: "false" }],
      operator: "eq"
    }
  ];
  return (
    <>
      <Grid item container spacing={2}>
        <Grid item sm={12} style={{ padding: 20 }} xs={12}>
          <Typography className="header-text">Dashboard </Typography>
        </Grid>
      </Grid>

      <Grid item container spacing={2}>
        <Grid item sm={12} xs={12}>
          <Grid item container spacing={2} flex={1}>
            <Grid item sm={12} xs={12} sx={{ marginBottom: 1 }}>
              <Card
                sx={{
                  transition: "0.3s",
                  width: "100%",
                  height: "100%",

                  "&:hover": {
                    boxShadow: 3 // Change the elevation on hover
                  }
                }}
              >
                <CardHeader
                  sx={{
                    "& .MuiTypography-root": {
                      fontSize: "1rem",
                      fontWeight: "bold"
                    }
                  }}
                  title={"Reconciliation"}
                />
              </Card>
            </Grid>
            {/* {barReconciliationYAxis && (
              <WSChart
                data={[]}
                series={barReconciliationYAxis}
                xAxis={barReconciliationXAxis}
                title={"Reconciliation Summary"}
                type="bar"
              />
            )} */}

            {/* {pieReconciliationData.length > 0 && (
              <Grid
                item
                xs={12}

              >
                <WSChart
                  data={pieReconciliationData}
                  title={"Reconciliation Summary"}
                  type="pie"
                  pieVisibility="None"
                />
              </Grid>
            )} */}

            {pieReconciliationData.length > 0 && (
              <Grid item xs={12}>
                <WSGoogleChart
                  pieVisibility="Straight Angle"
                  title={"Reconciliation Summary"}
                  type="pie"
                  data={pieReconciliationData}
                />
              </Grid>
            )}

            <Grid item sm={6} xs={12}>
              <WSGoogleChart
                is3D={true}
                pieVisibility="Center"
                title={"Total Amount Today"}
                type="pie"
                data={totalPayment}
              />
            </Grid>
            <Grid item sm={6} xs={12}>
              <WSGoogleChart
                is3D={true}
                pieVisibility="Center"
                title={"Cheque Summary"}
                type="pie"
                data={chechkIssuedList}
              />
            </Grid>
            {/* < Grid item sm={12} xs={12} > */}

            {/* </Grid> */}

            <Grid item sm={12} mt={2} xs={12} sx={{ marginTop: 0 }}>
              {/* <WSViewAllLinkGrid rowsCount={10000} title={`Today's Payment Summary `} id="paymentsummary" columns={columnsSummary} rows={summaryList} hideViewAllLink={true} /> */}
              <WSDataGridForDashboard
                titleSpace={12}
                id="todayPaymentsummary"
                title={`Today's Payment Summary`}
                columns={columnsSummary}
                data={summaryList}
              />
            </Grid>
            {/* <Paper sx={{ marginTop: 5, marginLeft: 2, width: '100%' }}> */}
            {/* <Grid item sm={12} mt={2} xs={12} sx={{ marginLeft: 2, marginRight: 2 }}>
                                <WSDateField control={control} id="dueDate" name="dueDate" rules={{ required: false }} onChange={handleFilterchange} label="Due Date" />
                            </Grid> */}
            <Grid item sm={12} mt={2} xs={12}>
              {/* <WSViewAllLinkGrid rowsCount={10000} title={`Bills`} viewAllLink="/billl/list" id="billDashboard" columns={columns} rows={billList} hideViewAllLink={true} /> */}
              <WSDataGridForDashboard
                pageSize={10}
                // searchBox={{ fieldName: "Category,InvoiceNo,Supplier.Name" }}
                // filterFields={filterRows}
                id="uu"
                title={`Bills`}
                columns={columnsDataBill}
                data={billList}
              />
            </Grid>
            {/* </Paper> */}
            <Grid item sm={12} mt={2} xs={12}>
              {/* <WSViewAllLinkGrid rowsCount={10000} title={`Summary`}  id="billSummary" columns={columns30days} rows={due30daysList} hideViewAllLink={true} /> */}
              {due30daysList && (
                <WSDataGridForDashboard
                  title={`Summary`}
                  columns={columns30days}
                  data={due30daysList}
                  id="oo"
                  pageSize={10}
                />
              )}
            </Grid>
            {/* <Grid item sm={8} xs={12}>
              < Grid item sm={12} xs={12}>
                                <WSGoogleChart is3D={true} pieVisibility="Center" title={"Department Leaves Chart"} type="pie" data={[]} />
                            </Grid>
            </Grid> */}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
});
